<template>
  <div class="share">
    <img src="../images/1.jpg" style="display: none" />
    <ul class="share-swipe" id="selector">
      <li class="share-content" v-for="d in imgBgUrl">
        <div class="share-content-img" :class="d"></div>
        <div class="share-content-info">
          <p class="pot">我定制了一款{{dataList.dishName}}口味，</p>
          <p>命名为：</p>
          <p class="newName">“{{dataList.potName}}！”</p>
          <p class="info-time-place">{{dataList.orderTime}}</p>
          <!--<p class="info-time-place"><span>{{dataList.memberName}}</span>&nbsp;{{dataList.shopName}}</p>-->
          <p class="info-time-place">
            <span>{{dataList.memberName}}</span>&nbsp;北京中骏世界城店
          </p>
        </div>
      </li>
    </ul>
    <div class="footer" @click="goToShare">邀请好友来品尝</div>
    <!-- 底部logo -->
    <div class="hhl-yqh-logo"></div>
    <!-- 模态框 -->
    <div class="shadow-chunk" v-show="shadowShow" @click="shadowShow = false">
      <p class="bg-arrows"></p>
      <p class="shadow-chunk-txt">点此邀请好友来品尝</p>
      <br />
      <p class="shadow-chunk-txt">私人定制仅北京中骏世界城店提供</p>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { Indicator, Toast } from 'mint-ui';
import ajax from '../../../pub/utils/ajaxUtils.js';
import { getPrivatePot, getJsParams } from './../config/api.js';
import mainUtils from '../.././../pub/utils/mainUtils';
import shareSwipe from './share-swipe.js'

let redata; //接受配置信息，后台给的
export default {
  name: 'index',
  data () {
    return {
      popUpsShow: false,// 模态框块
      shadowShow: false,// 命名模态框
      shareShow: false,// 分享模态框
      dishDetailId: '',// getDishPot(接口) -- id
      dataList: {},
      propsInfo: {},
      imgUrl: {
        '01060064': ['NYMLDT', 'NYML'],
        '01060061': ['QYMLDT', 'QYML'],
        '01060066': ['FQDT', 'FQ'],
        '01060228': ['LXFDT', 'LXF'],
      },
      imgBgUrl: [],
      imgBgUrls: '',
      x0: '',
      y0: '',
      hasmoved: '',
      leftFlag: true
    }
  },
  methods: {
    // 详情
    getPrivatePot () {
      let params = {
        dishDetailId: this.dishDetailId,
        privateCustomId: this.propsInfo.privateCustomId || '',
      };
      ajax.postJson(getPrivatePot, params,
        data => {
          this.dataList = data.obj;
          if (this.dataList.dishName.includes('火锅')) {
            this.dataList.dishName = this.dataList.dishName.replace('火锅', "");
          }
          this.$set(this.propsInfo, 'phone', this.dataList.phone);
          this.$set(this.propsInfo, 'dishListDetailId', this.dataList.dishListDetailId);
          sessionStorage.setItem('p', JSON.stringify(this.propsInfo));

          this.$nextTick(() => {
            // 处理高度
            let _li = document.getElementsByClassName('share-content')[0];
            let _ul = document.getElementById('selector');
            let _liH = window.getComputedStyle(_li).height
            _ul.style.cssText += `height: ${_liH}`;

            this.imgBgUrls = this.imgBgUrl[0];
            new shareSwipe("#selector");
            document.getElementById('selector').addEventListener("touchstart", this.touchstartHandle);
            document.getElementById('selector').addEventListener("touchmove", this.touchmoveHandle);
            this.share();
          });
        }
      );
    },
    // 微信分享
    goToShare () {
      this.shadowShow = true;// 遮罩
      this.shareShow = true;
    },
    share () {
      this.$nextTick(() => {
        //初始化微信JS
        try {
          let params = {
            // url: encodeURIComponent(location.href.split('#')[0])
            url: location.href.split('#')[0]
          };
          axios.post(getJsParams, params)
            .then(response => {
              redata = response.data.obj
              wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: redata.appId, // 必填，公众号的唯一标识
                timestamp: redata.timestamp, // 必填，生成签名的时间戳
                nonceStr: redata.noncestr, // 必填，生成签名的随机串
                signature: redata.signature, // 必填，签名，见附录1
                jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              });
            })
            .catch(error => {
              console.log(error);
            });
        }
        catch (e) {
          console.log(e);
          console.log('微信初始化出问题了');
        }
        try {
          let self = this;
          let _title = '我的海底捞私人定制尊享味道，邀你品尝';
          let links = 'https://q.haidilao.com/#/collect' +
            '?dishDetailId=' + this.dishDetailId
            + '&privateCustomId=' + this.propsInfo.privateCustomId
            + '&imgBgUrl=' + this.imgBgUrls;
          let descs = this.dataList.dishName + '口味';
          let _img = 'https://q.haidilao.com/static/img/1.9df916c.jpg';
          wx.ready(function () {
            //分享朋友圈代码
            wx.onMenuShareTimeline({
              title: _title, // 分享标题
              link: links,// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: _img, // 分享图标
              success: function () {
                // 用户点击了分享后执行的回调函数 -- 官方公告：微信公众平台开始逐步回收“分享回调”
                self.shadowShow = false;
              },
              cancel: function () {
                self.shadowShow = false;
              }
            });
            // 分享给朋友
            wx.onMenuShareAppMessage({
              title: _title, // 分享标题
              link: links,
              desc: descs,// 分享描述
              imgUrl: _img,// 分享图标
              success: function () {
                self.shadowShow = false;
              },
              cancel: function () {
                self.shadowShow = false;
              }
            });
          });
        }
        catch (e) {
          console.log(e);
        }
      })
    },
    touchstartHandle (e) {
      let touch = e.targetTouches[0], x = touch.pageX, y = touch.pageY;
      this.x0 = x;
      this.y0 = y;
      this.hasmoved = 0;
    },
    touchmoveHandle (e) {
      let flag = document.getElementsByClassName('share-content')[0].style.zIndex == 3;
      flag ? this.imgBgUrls = this.imgBgUrl[0] : this.imgBgUrls = this.imgBgUrl[1];
      let touch = e.targetTouches[0], x = touch.pageX, y = touch.pageY, offsetX = this.x0 - x, offsetY = this.y0 - y;
      // 阻止滚动
      this.hasmoved || (this.hasmoved = 1, Math.abs(offsetX) > Math.abs(offsetY) && e.preventDefault());
      if (offsetX <= -50) {
        // 向右
        if (!this.leftFlag) {
          this.leftFlag = true;
          this.share();
        }
      }
      else if (offsetX >= 50) {
        // 向左
        if (this.leftFlag) {
          this.leftFlag = false;
          this.share();
        }
      }
    },
  },
  created () {
    let u = navigator.userAgent;
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    if (isIOS) {
      if (sessionStorage.getItem('isIOS') === '1') {
        sessionStorage.setItem('isIOS', '2');
        // ios端刷新页面获取真正要分享的url
        location.reload();
      }
    }
    this.propsInfo = JSON.parse(sessionStorage.getItem('p'));
    if (!this.propsInfo) {
      let pathName = mainUtils.pathName();
      for (let i in pathName) {
        this[i] = pathName[i];
      }
      this.$router.push({
        path: '/collect',
        query: { dishDetailId: this.dishDetailId, privateCustomId: this.privateCustomId }
      });
      return;
    }
    for (let d in this.imgUrl) {
      if (this.propsInfo.dishCode === d) {
        this.imgBgUrl = this.imgUrl[d];
      }
    }
    this.dishDetailId = this.propsInfo.id;
    this.getPrivatePot();
  }
}
</script>
<style type="text/stylus" lang="stylus" scoped>
@import '../../../assets/css/func.styl';
@import './../share-bg.styl';

.share {
  box-sizing: border-box;
  width: 100%;
  padding: 0.3rem 0.42rem 0;
  overflow: hidden;

  .share-swipe {
    position: relative;
    width: 100%;
    height: 9.8rem;
    margin-bottom: 0.1rem;
  }

  .share-content {
    position: absolute;
    width: 6.66rem;
    border-radius: 0.2rem;
    box-shadow: 0 0.02rem 0.6rem #e5e5e5;
  }

  .share-content-img {
    width: 6.66rem;
    height: 6.66rem;
    border-top-left-radius: 0.2rem;
    border-top-right-radius: 0.2rem;
  }

  .share-content-info {
    padding-left: 0.28rem;
    padding-right: 0.3rem;
    line-height: 0.3rem;
    font-size: 0.3rem;
    color: #3f3f3f;

    .pot {
      margin-top: 0.3rem;
      margin-bottom: 0.26rem;
    }

    .newName {
      margin-top: 0.34rem;
      margin-bottom: 0.1rem;
      white-space: normal;
      word-break: break-all;
      /* margin-bottom .84rem */
      line-height: 0.36rem;
      font-size: 0.36rem;
      font-weight: 900;
    }

    .info-time-place {
      margin-bottom: 0.28rem;
      text-align: end;
      line-height: 0.22rem;
      font-size: 0.22rem;
      color: #8b8b8b;

      span {
        color: #e60012;
      }
    }
  }

  .footer {
    height: 0.88rem;
    line-height: 0.88rem;
    text-align: center;
    font-size: 0.34rem;
    color: #fff;
    border-radius: 0.1rem;
    background: #e60012;
  }

  /* background: linear-gradient(to right, #fd4b58, #fa8751)
  box-shadow: 0 3px 3px #fe8d8c inset, 0 3px 3px #eee */
  .hhl-yqh-logo {
    width: 2.5rem;
    height: 0.42rem;
    margin: 0.42rem auto 0rem;
    bg('../images/logo_yqhh');
  }

  .shadow-chunk {
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 0.42rem;
    background-color: rgba(0, 0, 0, 0.6);

    .bg-arrows {
      width: 1.84rem;
      height: 1.95rem;
      margin: 0.36rem 0 0.42rem 4.5rem;
      bg('../images/img_arrow');
    }

    .shadow-chunk-txt {
      text-align: end;
      font-size: 0.36rem;
      color: #fff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/share/share/share.vue